import PropTypes from 'prop-types'
import React, { Children } from 'react'
import { Button } from './Button'
import { Menu } from './Menu'

// An action segment and a chevron trigger for its menu of related
// actions. The className is the role and size of both segments; the other
// props reach the action segment, and aria-disabled holds both unless
// menuDisabled sets the chevron's own state. With no menu items the action
// renders alone.
export function SplitButton({
  children,
  menuLabel,
  menuId,
  menuMinWidth,
  align = 'end',
  className = 'me-btn me-btn-secondary',
  items,
  menuDisabled,
  ...props
}) {
  const action = (
    <Button {...props} className={className}>
      {children}
    </Button>
  )
  if (!Children.toArray(items).length) return action
  return (
    <span className="me-btn-split">
      {action}
      <Menu
        id={menuId}
        label={menuLabel}
        iconOnly
        icon="fa-regular fa-chevron-down me-btn-caret"
        className={className}
        align={align}
        minWidth={menuMinWidth}
        aria-disabled={
          menuDisabled === undefined ? props['aria-disabled'] : menuDisabled
        }
      >
        {items}
      </Menu>
    </span>
  )
}

SplitButton.propTypes = {
  // The action segment's label.
  children: PropTypes.node.isRequired,
  // The menu items: me-menu-item buttons or links.
  items: PropTypes.node,
  // The chevron trigger's accessible name and its menu's name.
  menuLabel: PropTypes.string.isRequired,
  menuId: PropTypes.string,
  // The menu surface's minimum width in CSS pixels (Menu minWidth).
  menuMinWidth: PropTypes.number,
  align: PropTypes.oneOf(['start', 'end']),
  className: PropTypes.string,
  'aria-disabled': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The chevron trigger's own aria-disabled, when it differs from the action's.
  menuDisabled: PropTypes.bool,
}
